import "./loader.scss";
function Loader() {
  return (
    <div className="loader">
      <div>
        <h1 className="title">Загрузка</h1>
        <div className="rainbow-marker-loader"></div>
      </div>
    </div>
  );
}

export default Loader;
